import React from "react";
import WholeLineContainer from "../../../../../../../Components/ReportFormTemplate/WholeLineContainer";
import CustomTextarea from "../../../../../../../Components/CustomInputs/CustomTextarea";
import { useDispatch, useSelector } from "react-redux";
import { StoreType } from "../../../../../../../redux/store/store";
import { shouldRenderSpecField } from "../../../../../../../redux/reducers/visibilityMatrixesReducer";
import { handleShowErrorMessage } from "../../../../../../../redux/reducers/claimFieldErrorsReducer";
import { updateFirstStepGeneralFields } from "../../../../../../../redux/reducers/claimReducer";
import CustomInput from "../../../../../../../Components/CustomInputs/CustomInput";
import { useScrollToTopErrorInput } from "../../../../../../../CustomHooks/useScrollToTopErrorInput";

const ContinuedTreatmentDoctorOrAmbulanceNameField: React.FC = () => {
   const fieldNameLowerCase = "continuedTreatmentDoctorOrAmbulanceName";
   const fieldNameUpperCase =
      fieldNameLowerCase.charAt(0).toUpperCase() + fieldNameLowerCase.slice(1);
   const dispatch = useDispatch();

   const fieldValue = useSelector(
      (state: StoreType) =>
         state.claimState.injuryDescriptionModelBase[fieldNameLowerCase]
   );

   const visibilityMatrixes = useSelector(
      (state: StoreType) => state.visibilityMatrixesState
   );

   const claimFieldErrorsMessages = useSelector(
      (state: StoreType) => state.claimFieldErrorsState
   );

   const { isChild, isThirdPerson } = useSelector(
      (state: StoreType) => state.claimState.reportModel
   );

   const { selectedTypeOfClaims } = useSelector(
      (state: StoreType) => state.claimState
   );

   const fieldHeading = () => {
      const isDeathBeingReported = selectedTypeOfClaims.some(
         (claim: string) => claim === "death"
      );
      if (isChild) {
         return isDeathBeingReported
            ? "Jméno, příjmení a adresa lékaře, či zařízení, kde se Vaše dítě léčilo"
            : "Jméno, příjmení a adresa lékaře, či zařízení, kde se Vaše dítě dále léčilo";
      } else if (isThirdPerson) {
         return isDeathBeingReported
            ? "Jméno, příjmení a adresa lékaře, či zařízení, u kterého se zesnulý/zesnulá léčil/a"
            : "Jméno, příjmení a adresa lékaře, či zařízení, u kterého se pojištěný/á dále léčil/a";
      } else {
         return isDeathBeingReported
            ? "Jméno, příjmení a adresa lékaře či zařízení, u kterého se zesnulý/zesnulá léčil/a"
            : "Jméno, příjmení a adresa lékaře či zařízení, kde jste se dále léčil/a?";
      }
   };
   const ref = React.useRef<HTMLDivElement>(null);
   useScrollToTopErrorInput(ref, fieldNameUpperCase);
   return (
      <WholeLineContainer
         dependencyValue={shouldRenderSpecField(
            "GeneralFields",
            fieldNameUpperCase,
            visibilityMatrixes
         )}
      >
         <CustomInput
            labelText={fieldHeading()}
            placeholderText="Uveďte lékaře a jeho adresu"
            value={fieldValue || ""}
            onChange={(e: any) => {
               dispatch(
                  updateFirstStepGeneralFields({
                     value: e.target.value,
                     field: fieldNameLowerCase,
                  })
               );
            }}
            validationText={handleShowErrorMessage(
               fieldNameUpperCase,
               claimFieldErrorsMessages
            )}
            maxCharacters="100"
            inputRef={ref}
         />
      </WholeLineContainer>
   );
};

export default ContinuedTreatmentDoctorOrAmbulanceNameField;
